import(/* webpackMode: "eager" */ "/home/runner/work/sapling/sapling/packages/foundation/src/app/global-error.tsx");
